import React from 'react'
import Leftpanel from '../layout/Leftpanel';
import Dashboardlayout from './Dashboardlayout';

const Index = () => {
    return (
        <>
                {/* <Leftpanel/> */}
                <Dashboardlayout/>
        </>
    )
}

export default Index


